import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "submitButton",
    "checkbox",
    "paidAmount",
    "errorMessage",
    "warningMessage",
  ];

  connect() {
    this.validateAmount();
  }

  validateAmount() {
    this.loadAmount();

    this.selectedCheckboxes = this.checkboxTargets.filter(
      (target) => target.checked
    );

    this.unselectedCheckboxes = this.checkboxTargets.filter(
      (target) => !target.checked
    );

    this.paymentsAmount = 0;

    this.selectedCheckboxes.forEach((selectedCheckbox) => {
      this.paymentsAmount += Number(selectedCheckbox.dataset.amount);
    });

    const paidAmountPresent = this.paidAmount;
    const matchingAmount = this.paidAmount <= this.paymentsAmount;

    const enableButton =
      paidAmountPresent &&
      (matchingAmount ||
        (!matchingAmount && this.unselectedCheckboxes.length === 0));

    this.errorMessageTarget.classList.toggle("hidden", paidAmountPresent);
    this.warningMessageTarget.classList.toggle("hidden", matchingAmount);
    this.submitButtonTarget.disabled = !enableButton;
  }

  loadAmount() {
    const sanitized = this.paidAmountTarget.value
      .replace(/[^\d.,]/g, "")
      .replace(/[.,](?=.*[.,])/g, "")
      .replace(",", ".");

    this.paidAmount = parseFloat(sanitized || 0) * 100;
  }
}
